/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { ReactElement, useCallback } from "react";
import { View } from "react-native";

interface MeasureProps {
  onMeasure: (width: number) => void;
  children: ReactElement;
}

export default function Measure({ onMeasure, children }: MeasureProps) {
  // Component to show child components dimensions.
  const ref = useCallback(
    (element) => {
      if (element !== null) {
        const width = element.offsetWidth;
        // const height = element.offsetHeight;
        onMeasure(width);
      }
    },
    [children]
  );

  return <View ref={ref}>{children}</View>;
}
